import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {alertTypes, useAlerts} from '../ui/alert';
import {constants, responseSelector} from '../utils/utils';
import {log} from '../utils/logs';
import {produccionSelectorGetDuck, produccionSelectorGetThunk} from './duck';
import {ProduccionSelectorView} from './ProduccionSelectorView';
import {useQueryParams} from '../utils/useQueryParams';

export const ProduccionSelector = ({history, token}) => {
  const {queryParams, queryParamsloaded} = useQueryParams(history);

  const dispatch = useDispatch();

  const [datos, setDatos] = useState({});

  const produccionSelectorGet = useSelector(
    state => state.produccionSelectorGet,
  );

  const {setTopAlert, topAlert} = useAlerts();

  useEffect(() => {
    const {data, httpStatus, error, errorMessage} = responseSelector(
      produccionSelectorGet,
    );

    if (error) {
      setTopAlert({
        title: 'Error',
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(produccionSelectorGetDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      setDatos(data);
      dispatch(produccionSelectorGetDuck.actions.clear());
    }
  }, [produccionSelectorGet]);

  useEffect(() => {
    if (!queryParamsloaded) {
      return;
    }

    submit(queryParams);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, queryParamsloaded]);

  const submit = queryParams => {
    const {selectorId, equipoId, fechaInicio, fechaFin, soyIframe} =
      queryParams;

    log({
      'submit.params': {selectorId, equipoId, fechaInicio, fechaFin, soyIframe},
    });

    dispatch(
      produccionSelectorGetThunk({
        selectorId,
        equipoId,
        fechaInicio,
        fechaFin,
        soyIframe,
        userToken: token.raw,
      }),
    );
  };

  return (
    <ProduccionSelectorView
      history={history}
      topAlert={topAlert}
      produccionSelectorGet={produccionSelectorGet}
      datos={datos}
      token={token}
      queryParams={queryParams}
    />
  );
};
